export default {
  "pwaNotificationTasks.thead.no": "#序号",
  "pwaNotificationTasks.thead.taskId": "任务ID",
  "pwaNotificationTasks.thead.title": "标题",
  "pwaNotificationTasks.thead.content": "内容",
  "pwaNotificationTasks.thead.url": "链接",
  "pwaNotificationTasks.thead.createTime": "创建时间",
  "pwaNotificationTasks.title": "PWA通知任务",
  "pwaNotificationTasks.action.details": "详情",
  "pwaNotificationTasks.modal.title.details": "任务详情",
  "pwaNotificationTasks.message.copySuccess": "复制成功！",
};